const API_URL = process.env.REACT_APP_API_URL || '';

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  // ── Status / Connection ──
  getStatus: (subAccountId) =>
    apiFetch(`/api/status?sub_account_id=${subAccountId}`),

  // RideDog
  getConnectUrl: (subAccountId) =>
    `${API_URL}/oauth/connect?sub_account_id=${subAccountId}`,
  disconnect: (subAccountId) =>
    apiFetch('/oauth/disconnect', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId }) }),

  // Lonestar
  connectLonestar: (subAccountId, apiKey) =>
    apiFetch('/lonestar/connect', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId, api_key: apiKey }) }),
  disconnectLonestar: (subAccountId) =>
    apiFetch('/lonestar/disconnect', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId }) }),

  // ── Trackers ──
  getTrackers: (subAccountId) =>
    apiFetch(`/api/trackers?sub_account_id=${subAccountId}`),
  getHistory: (subAccountId, trackerId, start, end) =>
    apiFetch(`/api/trackers/${trackerId}/history?sub_account_id=${subAccountId}&start=${start}&end=${end}`),

  // ── Alerts ──
  getAlerts: (subAccountId) =>
    apiFetch(`/api/alerts?sub_account_id=${subAccountId}`),
  saveAlert: (subAccountId, data) =>
    apiFetch('/api/alerts', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId, ...data }) }),
  deleteAlert: (subAccountId, trackerId, label) =>
    apiFetch(`/api/alerts/${trackerId}?sub_account_id=${subAccountId}${label ? `&label=${encodeURIComponent(label)}` : ''}`, { method: 'DELETE' }),
  resetAlert: (subAccountId, trackerId, label, currentMiles, servicedAt) =>
    apiFetch(`/api/alerts/${trackerId}/reset`, {
      method: 'POST',
      body: JSON.stringify({ sub_account_id: subAccountId, label, current_miles: currentMiles, serviced_at: servicedAt || Math.floor(Date.now() / 1000) }),
    }),
  getAlertHistory: (subAccountId) =>
    apiFetch(`/api/alerts/history?sub_account_id=${subAccountId}`),
};

export const manualTrailerApi = {
  add: (subAccountId, name, description) =>
    apiFetch('/api/manual-trailers', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId, name, description }) }),
  update: (subAccountId, trailerId, name, description) =>
    apiFetch(`/api/manual-trailers/${trailerId}`, { method: 'PUT', body: JSON.stringify({ sub_account_id: subAccountId, name, description }) }),
  remove: (subAccountId, trailerId) =>
    apiFetch(`/api/manual-trailers/${trailerId}?sub_account_id=${subAccountId}`, { method: 'DELETE' }),
  link: (subAccountId, trailerId, ridedogTrackerId, ridedogTrackerName) =>
    apiFetch(`/api/manual-trailers/${trailerId}/link`, { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId, ridedog_tracker_id: ridedogTrackerId, ridedog_tracker_name: ridedogTrackerName }) }),
  unlink: (subAccountId, trailerId) =>
    apiFetch(`/api/manual-trailers/${trailerId}/unlink`, { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId }) }),
};

export const serviceApi = {
  getLog: (subAccountId, trackerId) =>
    apiFetch(`/api/service-log?sub_account_id=${subAccountId}${trackerId ? `&tracker_id=${trackerId}` : ''}`),
  add: (subAccountId, data) =>
    apiFetch('/api/service-log', { method: 'POST', body: JSON.stringify({ sub_account_id: subAccountId, ...data }) }),
  update: (subAccountId, id, data) =>
    apiFetch(`/api/service-log/${id}`, { method: 'PUT', body: JSON.stringify({ sub_account_id: subAccountId, ...data }) }),
  remove: (subAccountId, id) =>
    apiFetch(`/api/service-log/${id}?sub_account_id=${subAccountId}`, { method: 'DELETE' }),
  exportUrl: (subAccountId, trackerId) =>
    `${API_URL}/api/service-log/export?sub_account_id=${subAccountId}${trackerId ? `&tracker_id=${trackerId}` : ''}`,
};
